import { makeStyles } from "tss-react/mui";
const useAutocompleteChipClasses = makeStyles()((theme) => ({
  autocompleteChipPreviouslyAssignedItemBadge: {
    "&.MuiBadge-root": {
      marginRight: theme.spacing(0.75)
    },
    "& .MuiBadge-anchorOriginTopRightRectangular": {
      position: "relative",
      top: `${theme.spacing(1.1)} !important`,
      background: theme.palette.background.paper,
      width: theme.custom.chipDeleteIconSize,
      height: theme.custom.chipDeleteIconSize
    }
  },
  autocompleteChipPreviouslyAssignedItemChip: {
    marginRight: theme.spacing(0.75)
  }
}));
export {
  useAutocompleteChipClasses
};
//# sourceMappingURL=AutocompleteChip.styles.js.map
